import { render, staticRenderFns } from "./seat-popover.vue?vue&type=template&id=23b36931&"
import script from "./seat-popover.vue?vue&type=script&lang=js&"
export * from "./seat-popover.vue?vue&type=script&lang=js&"
import style0 from "./seat-popover.vue?vue&type=style&index=0&id=23b36931&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports